import { basePageTitle, pageTitleTemplate } from '@/config';

export default function(title) {
  let newTitle;
  if (title) {
    newTitle = pageTitleTemplate.replace('{title}', title);
  } else {
    newTitle = basePageTitle;
  }

  return newTitle;
}
